export default __webpack_public_path__ + "static/media/wPants_1_c1.a444622d.jpeg";